import { useEffect, useState } from "react";

// Returns the input value after `delayMs` of stability. Use to throttle expensive
// reactions (e.g. firing a network request as the user types).
export const useDebounce = (value, delayMs) => {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const handle = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(handle);
  }, [value, delayMs]);

  return debounced;
};
